// extracted by mini-css-extract-plugin
module.exports = {"loading":"NewLoader_loading__10Lur","loading_with_bg":"NewLoader_loading_with_bg__3AiUR","loaderAnimation":"NewLoader_loaderAnimation__3BPEu"};